import '../styles/Features.css';

export default function Features() {
  return (
    <section id='features' className="features">
      <div className="features-container">

        <div className="feature-card">
          <h3>SERVICIOS</h3>
          <h4>Estructuración y gestión de inversiones.</h4>
          <p>
            Nuestro trabajo se centra en facilitar acuerdos entre personas con objetivos alineado. Desde el contacto con propietarios que desean vender su vivienda de forma eficaz y fuera de mercado, hasta la búsqueda de inquilinos a largo plazo, abordamos cada operación con un enfoque práctico y personalizado.
          </p>
          <p>
            Además, proponemos soluciones como reformas, arreglos o incluso el vaciado del inmueble, siempre con el único propósito de facilitar el crecimiento de nuestros clientes y simplificar la toma de decisiones.
          </p>
        </div>

        <div className="feature-card">
          <h3>PROPÓSITO</h3>
          <h4>Demostrar.</h4>
          <p>
            El sector se ha visto afectado por malas prácticas que han alejado a las personas de la confianza. Nuestra vocación siempre ha sido demostrar que se puede trabajar de otra manera, estando disponibles, dando la cara y asumiendo cada situación con responsabilidad.
          </p>
          <p>
            Entendemos que nuestro trabajo no consiste en evitar que surjan los problemas, sino en afrontarlos y resolverlos de la forma más eficiente y honesta posible.
          </p>
          <p>
            Así conseguimos que, incluso en operaciones que a veces resultan frías, las personas sigan ocupando el lugar que les corresponde, y reciban el trato que todos merecemos.
          </p>
        </div>

        <div className="feature-card">
          <h3>MÉTODO</h3>
          <h4>Criterio y ejecución.</h4>
          <p>
            Centramos nuestros esfuerzos en comprender y resolver las expectativas de nuestros clientes, procurando que cada desarrollo sea sencillo y natural.
          </p>
          <p>
            Nos implicamos activamente en la operación, apoyando, facilitando y asesorando allí donde es necesario.
          </p>
          <p>
            Trabajamos junto a los profesionales más cualificados para que nuestros clientes dispongan de la información adecuada en la toma de decisiones y, en definitiva, para que puedan tomar decisiones bien fundamentadas.
          </p>
        </div>

      </div>
    </section>
  );
}